import React, { useState, useMemo } from 'react';
import styles from './Canvasses.module.css';

const StakeholderSearch = ({ stakeholders, onSelect, loading, error, selectedStakeholderId, userCompanies }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');

  const filteredStakeholders = useMemo(() => {
    let filtered = stakeholders;

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(stakeholder => 
        stakeholder.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        stakeholder.objective?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        stakeholder.metadata?.stakeholderType?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by type
    if (filterType !== 'all') {
      filtered = filtered.filter(stakeholder => {
        if (filterType === 'internal') return stakeholder.isInternal;
        if (filterType === 'external') return !stakeholder.isInternal;
        return true;
      });
    }

    return filtered;
  }, [stakeholders, searchTerm, filterType]);

  if (loading) {
    return <div>Loading public stakeholders...</div>;
  }

  return (
    <div className={styles.stakeholderSearch}>
      {error && <div className={styles.errorMessage}>{error}</div>}
      
      <div className={styles.searchFilters}>
        <div className={styles.searchInput}>
          <input
            type="text"
            placeholder="Search stakeholders..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.formInput}
          />
        </div>
        
        <div className={styles.filterSelect}>
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className={styles.formInput}
          >
            <option value="all">All Types</option>
            <option value="internal">Internal</option>
            <option value="external">External</option>
          </select>
        </div>
      </div>

      <div className={styles.stakeholderList}>
        {filteredStakeholders.length === 0 ? (
          <div className={styles.emptyState}>
            <p>No public stakeholders found</p>
            <small>Try adjusting your search or filters.</small>
          </div>
        ) : (
          filteredStakeholders.map(stakeholder => {
            const company = userCompanies.find(c => c.id === stakeholder.parentCompanyId);
            return (
              <div 
                key={stakeholder.id} 
                className={`${styles.stakeholderItem} ${selectedStakeholderId === stakeholder.id ? styles.selectedItem : ''}`}
                onClick={() => onSelect(stakeholder)}
              >
                <div className={styles.stakeholderName}>
                  <strong>{stakeholder.name}</strong>
                  {stakeholder.objective && (
                    <span className={styles.stakeholderObjective}>
                      {stakeholder.objective}
                    </span>
                  )}
                  <span className={styles.stakeholderType}>
                    {stakeholder.metadata?.stakeholderType || 'Stakeholder'}
                  </span>
                  <span className={styles.stakeholderCompany}>
                    {company?.name || 'Unknown Company'}
                  </span>
                  <span className={`${styles.categoryBadge} ${stakeholder.isInternal ? styles.internalCategory : styles.externalCategory}`}>
                    {stakeholder.isInternal ? 'Internal' : 'External'}
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default StakeholderSearch;
